export default __webpack_public_path__ + "static/media/laissa-orsano.ffa451c1.jpg";